import React, { useEffect, useState } from 'react'
import './Details.css'
import img_back from '../../img/y-copy.png'
import { getDetailsdata } from '../../api'
import { useLocation, useNavigate } from 'react-router'
import getNum from '../../method/method'
import starsScore from '../../method/start'
// import Disimage from './Disimage/Disimage'
import { insert_adv, remove_adv } from '../../method/addadv'
import Footer from '../Home/Footer/Footer'
import { iframeLoad } from '../../method/analytics'

export default function Details() {
  const [data, setData] = useState({})
  const [dataarr, setDataarr] = useState([])
  const [imgdata, setImgdata] = useState([])

  const { search } = useLocation()
  const navigate = useNavigate()

  /* 返回上一页 */
  const goback = () => {
    window.location = '/'
  }
  // 获取详情页数据

  /* // 跳转详情
  const goDeta = (para) => {
    window.location = "/page/details?gid=" + para
    getdata("?gid=" + para)
    window.scrollTo(0, 0)
  } */

  /* // 下载游戏
  const playgame = (__url) => {
    window.location = __url
  } */

  /* 监听路由 */
  useEffect(() => {
    const getdata = para => {
      getDetailsdata(para).then(res => {
        // console.log(res.data);
        setData(res.data)
        setDataarr(res.data.recommend)
        setImgdata(res.data.preview)
      })
    }
    getdata(search)
  }, [search])

  /* 页面挂载后 */
  useEffect(() => {
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, document.URL)
      window.addEventListener('popstate', navigate(-1), false)
    }

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      // 广告加载 上传分析
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [navigate])

  return (
    <div className="details">
      <div className="deta-head">
        <img src={img_back} alt="" onClick={goback} />
      </div>

      {/* 下载量详情 */}
      <div className="de-title">
        {/* left */}
        <div className="tit-left">
          <img src={process.env.REACT_APP_BASEURL + data.icon} alt="" />
          <div className="de-content">
            <h3 className="game-n">{data.name}</h3>
            <span>Hot Game</span>
            <p>
              {starsScore(data.score)} {data.score}
            </p>
            {/* <p style={{ color: 'blueviolet' }}>Author：{data.author}</p> */}
          </div>
        </div>

        {/* right */}
        <div className="tit-right">
          <p>
            <span>{getNum(data.count)}</span> player
          </p>
        </div>
      </div>

      {/* 广告一 *************************** */}
      <div className="adv_box">
        <p>Advertisement</p>
        <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
      </div>

      <div className="btn-box">
        <a href={data.link} className="dis_a">
          <button className="de-btn">play</button>
        </a>
      </div>

      {/* 游戏详情图片 */}
      <div className="game-content">
        <h2>Preview</h2>

        <div className="img-view">
          {imgdata?.map(item => (
            <img src={process.env.REACT_APP_BASEURL + item} key={item} alt="" /* onClick={() => img_dis(item)} */ className="list_img" />
          ))}
          {/* 放大图片 */}
          {/* <Disimage imgsrc={img_c} flag={img_f} setImg={img_none}></Disimage> */}
        </div>
      </div>

      <h2 className="desc">Description</h2>
      <p>{data.description}</p>

      <div className="gl-content">
        <h1>You might like.</h1>
        {/* 游戏列表区 */}
        <ul>
          {dataarr?.map(item => (
            <li key={item.gid}>
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <div>
                  <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                  <div>
                    <h3>{item.name}</h3>
                    <p>
                      {starsScore(item.score)} {data.score}
                    </p>
                    <span>{getNum(item.count)}</span>
                  </div>
                </div>

                <span>play</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* 广告二 *************************** */}
      <div className="adv_box">
        <p>Advertisement</p>
        <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
      </div>

      <Footer></Footer>
    </div>
  )
}
